import { ConsentRequest } from '../../../interfaces/consent-request';
import { User } from '../../../interfaces/user';
import { ConsentRequestType } from '../../../interfaces/consent-request-type';
import { ConsentStatus } from '../../../interfaces/consent-status';
import { Paginator, PaginatorInfo } from '../../../types/paginator';
import { APPROVAL_FIELDS } from '../individual-approvals-dialog/graphql/individual-approvals';
import { gql } from 'apollo-angular';
import { ConsentRequestFilterInput } from '../../consent-requests/graphql/consent-requests';
import ConsentRequiredStatus from '../../../interfaces/consent-required-status';
import ConsentApprovalStatus from '../../../interfaces/consent-approval-status';

type RequestsWithApprovalsResponse = {
  getConsentRequests: Paginator<ConsentRequest, PaginatorInfo>;
  me: User;
  getConsentRequestTypes: ConsentRequestType[];
  getConsentStatuses: ConsentStatus[];
  getConsentRequiredStatuses: ConsentRequiredStatus[];
  getConsentApprovalStatuses: ConsentApprovalStatus[];
};
type RequestsWithApprovalsVariables = {
  page: number;
  excludeStatuses?: string[] | null;
};
const REQUEST_FIELDS = gql`
    fragment ConsentRequestPaginatorFields on ConsentRequestPaginator{

      data{
        id
        project {
          id
          name
          developer {
            id
            name
          }
          participants(withRole: ["Sponsor"]){
            id
            role {
              name
            }
            person {
              id
              name
            }
            organization {
              id
              name
            }
            sponsor {
              id
              name
              is_repeat
              nickname
            }
          }
        }
        consent_request_type_id
        received_date
        timing_date
        urgency_note
        is_urgent_flag
        details
        consent_status_id
        hasPastDue
        consentRequestApprovals {
          ${APPROVAL_FIELDS}
        }
      }
      paginatorInfo {
        currentPage
        hasMorePages
        perPage
        lastPage
        total
      }
    }
`;
export const GET_REQUESTS_WITH_APPROVALS = gql<
  RequestsWithApprovalsResponse,
  RequestsWithApprovalsVariables
>`
  query getRequestsWithApprovals($page: Int, $excludeStatuses: [String!]) {
    getConsentRequests(
      page: $page
      excludeStatuses: $excludeStatuses
      order: [
        { column: IS_URGENT_FLAG, order: ASC }
        { column: TIMING_DATE, order: DESC }
        { column: RECEIVED_DATE, order: DESC }
      ]
    ) {
      ...ConsentRequestPaginatorFields
    }
    getConsentStatuses {
      id
      status
      sort_index
    }
    getConsentRequestTypes {
      id
      request_type
    }
    getConsentApprovalStatuses {
      id
      status
      is_approval
    }
    getConsentRequiredStatuses {
      id
      required_status
    }
    me {
      id
      permissionsForResource(resourceType: CONSENTREQUESTAPPROVAL) {
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
    }
  }
  ${REQUEST_FIELDS}
`;
export type RefreshRequestsWithApprovalsResponse = {
  getConsentRequests: Paginator<ConsentRequest, PaginatorInfo>;
};
export type RefreshRequestsWithApprovalsVariables = {
  page: number;
  excludeStatuses?: string[] | null;
  filter?: ConsentRequestFilterInput | null;
};
export const REFRESH_CONSENT_REQUESTS_WITH_APPROVALS = gql<
  RefreshRequestsWithApprovalsResponse,
  RefreshRequestsWithApprovalsVariables
>`
  query refreshRequestsWithApprovals(
    $page: Int
    $excludeStatuses: [String!]
    $filter: ConsentRequestFilterInput
  ) {
    getConsentRequests(
      page: $page
      excludeStatuses: $excludeStatuses
      filter: $filter
      order: [
        { column: IS_URGENT_FLAG, order: ASC }
        { column: TIMING_DATE, order: DESC }
        { column: RECEIVED_DATE, order: DESC }
      ]
    ) {
      ...ConsentRequestPaginatorFields
    }
  }
  ${REQUEST_FIELDS}
`;
